'use strict';

var _ = require('lodash');
var TrendChartDtdAggregationFactory = function TrendChartDtdAggregationFactory(DataAggregationFactory, configurationSerivce, $filter) {
  var parsedRTPS = configurationSerivce.getParsedRTPS();
  var rmMomentFormat = $filter('rmMomentFormat');
  function recordComparator(a, b) {
    return a.d1 - b.d1;
  }
  function dateComparator(a, b) {
    return a.d1.valueOf() - b.d1.valueOf();
  }
  function TrendChartDtdAggregation() {
    DataAggregationFactory.call(this, 'rom-analysis-flattened-services-mode', 'trend-chart-dtd');
  }
  TrendChartDtdAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  TrendChartDtdAggregation.constructor = TrendChartDtdAggregation;
  TrendChartDtdAggregation.prototype.aggregate = function (data, metricsKeys) {
    var resultMap = {};
    for (var i = 0; i < data.length; i++) {
      var record = data[i];
      resultMap[record.romTimeBucket] = resultMap[record.romTimeBucket] || {};
      var optGroupWeek = record.optGroupWeek;
      var currentDtdData = resultMap[record.romTimeBucket];
      currentDtdData[optGroupWeek] = currentDtdData[optGroupWeek] || {
        m1: 0,
        m2: 0,
        d1: record.optGroupWeekMoment,
        d2: record.daysToDeparture,
        stackLabel: rmMomentFormat(record.optGroupWeekMoment, 'DATE_USER_SETTINGS')
      };
      var currentDepDayData = currentDtdData[optGroupWeek];
      currentDepDayData.m1 += this.getMetricValue(record.spillPaxGap, metricsKeys, true);
      currentDepDayData.m2 += this.getMetricValue(record.recapPaxGap, metricsKeys, true);
    }
    var result = _.transform(resultMap, function (result, value, key) {
      result.push({
        d1: key,
        containerData: _.values(value).sort(dateComparator)
      });
    }, []);
    result.sort(recordComparator);
    _.forEach(result, function (record) {
      record.d1 = parsedRTPS[record.d1];
    });
    return result;
  };
  return TrendChartDtdAggregation;
};
TrendChartDtdAggregationFactory.$inject = ['AbstractROMServiceAggregationFactory', 'ConfigurationService', '$filter'];
module.exports = TrendChartDtdAggregationFactory;